module.exports = __webpack_public_path__ + "static/media/icon-compare.df342ac5.svg";